import moment from 'moment'

export default {
	"entityName": "returned",
	"upsert": "full",
    filterStorage: {},
	// "title": "Site request",
	"pagination": {
		"itemsPerPage": 10,
		"page": 1,
		"sortBy": "request_date",
		"descending": true
	},
	"fields": [
		{
			text: 'Date',
			value: 'request_date',
			table: {
				filter: true
			},
			visible: false,
			render: item => moment(item.request_date).format('YYYY-MM-DD'),
		},
		{
			text: 'Package ready from',
			value: 'box',
			small: true,
			type: 'datetime',
			min: true,
			visible: item => item.status === 'INIT',
			validators: [
				'required',
				(field, value) => moment().isSameOrBefore(moment(value),'day') || `Can't be in the past`
			]
		},
		{
			"value": "protocol_id",
			type: 'autocomplete',
			"text": "Protocol",
			"table": {
				"sortable": true,
				filter: true
			},
			"title": "name",
			small: true,
			validators: ['required'],
			visible: false
		},
		{
			"value": "site.city",
			"text": "Site",
			render: ({ site }) => site && `${site.city} - ${site.name}`,
			filter: (item, search) => {
				if (search) return [{ 'site.name': `%${search}%`}, { 'site.city': `%${search}%`}, { 'site.code': `%${search}%`}]
			},
			"table": {
				sortable: true,
				filter: true
			},
			readonly: true,
			visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User' || state.user.role === 'Monitor',
		},
		// {
		//     small: true,
		//     value: 'department'
		// },
		{
			text: 'Status',
			value: 'status',
			type: 'list',
			list: ['INIT', 'REQUESTED', 'CONFIRMED', 'CANCELED'],
			table: {
				filter: true
			},
			visible: false
		},
		{
			full: true,
			value: 'note',
			text: 'Note',
			visible: (item) => item.note, // && state.user.role === 'Administrator' || state.user.role === 'EMN User'),// && (['NEW', 'REQUESTED', 'CONFIRMED', 'SENT'].includes(item.status) || (['RECEIVED', 'CANCELED', 'LOST'].includes(item.status) && item.note)),
			// readonly: item => ['RECEIVED', 'CANCELED', 'LOST'].includes(item.status),            
			type: 'textarea',
		},
		{
			value: 'returned_drugs.name',
			text: 'Drugs',
			id: 'id',
			filter: (item, search) => search && [{ 'returned_drugs.name': `%${search}%` }],
			subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
			type: 'autocomplete',
			table: {
					filter: true,
			},
			render: item => 
					item.returned_drugs && item.returned_drugs.reduce((drugs, drug, idx) => drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${item.drugs[idx] && (item.drugs[idx].n_pieces + '/' + item.drugs[idx].n_partially)}) ` , ''),
			visible: false
		}
	],
	actions: ['upsert', 'audit']
}
